import type { FC } from 'react';
import type { Dayjs } from 'dayjs';
import classes from './DayPicker.module.css';
import { isDisabled, WORKING_DAYS } from '../../../../../constants/datetimes';

export type DayPickerProps = {
  day: Dayjs;
  selectDay: (day: Dayjs) => void;
};

export const DayPicker: FC<DayPickerProps> = ({ day, selectDay }) => {
  return (
    <div className={classes.daysContainer}>
      <div className={classes.weekContainer}>
        {WORKING_DAYS().map((el) => (
          <div key={el.format()} className={classes.circle}>
            <span className={classes.days}>{el.format('ddd')}</span>
          </div>
        ))}
      </div>
      <div className={classes.divider} />
      <div className={classes.weekContainer}>
        {WORKING_DAYS().map((workingDay) => (
          <button
            data-testid={`dayPicker-selectDay-${workingDay.format(
              'YYYY-MM-DD'
            )}`}
            className={`${classes.circle} ${
              !workingDay.format('d').includes('0') &&
              ` ${classes.circleColored} bg-spk-softBlue`
            } ${
              day && day.isSame(workingDay, 'day') && ' !bg-employer-primary'
            }`}
            onKeyDown={() => selectDay(workingDay)}
            onClick={() => selectDay(workingDay)}
            type="button"
            tabIndex={0}
            key={workingDay.format()}
            disabled={isDisabled(workingDay)}
          >
            <span
              className={`${classes.days} ${
                day && day.isSame(workingDay, 'day') && classes.daySelected
              }`}
            >
              {workingDay.format('D')}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
